import { CardSvg } from '@/play/cardSvg'

/**
 * Home card art for Spell it: a shelf with three painted slots, two filled with blocks whose letters
 * sparkle like gems (O P), the third waiting; the last block (A) on its way, lifted with its shadow;
 * a mouth saying the word. No text: the letters are strokes.
 */
export function SpellItCardArt() {
  return (
    <CardSvg bg="#f3f6f8">
      <path d="M10 190 L 50 128 H 300 L 312 190 Z" fill="#dfe6ea" />
      <path d="M44 94 H 300 L 296 112 H 40 Z" fill="#a8774f" />
      <path d="M40 112 H 296 V 132 H 40 Z" fill="#8f6040" />
      <path d="M190 98 H 236 L 233 108 H 186 Z" fill="#6b4529" stroke="#c99a6b" strokeWidth="2" />
      <Block x={86} y={60} ink="#2a9d4b" letter="M24 8 C 14 8, 14 30, 24 30 C 34 30, 34 8, 24 8 Z" gem />
      <Block x={136} y={60} ink="#f28c28" letter="M17 30 V 8 H 26 C 34 8, 34 20, 26 20 H 17" gem />
      <ellipse cx="214" cy="104" rx="20" ry="4" fill="#1d2b36" opacity="0.2" />
      <Block x={192} y={28} ink="#2f7dd1" letter="M15 30 L 24 8 L 33 30 M 18 22 H 30" />
      <path d="M252 150 Q 262 144, 270 150 Q 262 160, 252 150 Z" fill="#e63946" stroke="#1d2b36" strokeWidth="2" />
      <path d="M276 144 Q 280 150, 276 156 M 282 139 Q 289 150, 282 161" fill="none" stroke="#1d2b36" strokeWidth="2.2" strokeLinecap="round" />
    </CardSvg>
  )
}

/** One block in a simple oblique view: top with the raised letter, front face; `gem`: the letter sparkles. */
function Block({ x, y, ink, letter, gem = false }: { x: number; y: number; ink: string; letter: string; gem?: boolean }) {
  return (
    <g transform={`translate(${x} ${y})`}>
      <path d="M0 10 L 10 0 H 48 L 38 10 Z" fill="#f1d3a6" stroke="#d2a86e" strokeWidth="1.5" />
      <rect x="0" y="10" width="38" height="26" fill="#e8c48e" stroke="#d2a86e" strokeWidth="1.5" />
      <path d="M38 10 L 48 0 V 26 L 38 36 Z" fill="#d2a86e" />
      <g transform="translate(-4 13) scale(0.9 0.75)">
        <path d={letter} fill="none" stroke={ink} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        {gem && <path d={letter} fill="none" stroke="#ffffff" strokeWidth="1.4" strokeLinecap="round" strokeDasharray="2 6" />}
      </g>
      {gem && <path d="M40 -8 L 42 -2 L 48 0 L 42 2 L 40 8 L 38 2 L 32 0 L 38 -2 Z" fill="#ffd60a" />}
    </g>
  )
}
